import { useLocalizeText } from '@mews/framework';

export const useNavigationPath = (parentPath: string, textKey: Mews.TextKey) => {
    const localizeText = useLocalizeText();
    return `${parentPath}${localizeText({ textKey })}`;
};
